import cx from 'classnames'

export type SemanticSize =
  | 'none'
  | 'condensed'
  | 'normal'
  | 'spacious'
  | 'display'

/**
 * Utility to generate consistent spacing with default values and semantic naming. See also the Stack component which uses this.
 *
 * @param gap The bidirectional gap between elements. Defaults to 'normal'.
 * @param padding The padding around the container. Defaults to 'none'.
 * @description NB that we deliberately don't work with margins but instead default to padding and gaps, as this makes it easier to reason about spacing in nested components.
 * @returns A string of class names to apply the specified spacing.
 */

export const spacingStyles = ({
  gap = 'normal',
  padding = 'none',
}: {
  gap?: SemanticSize
  padding?: SemanticSize
} = {}) =>
  cx(
    {
      none: '',
      condensed: 'gap-1',
      normal: 'gap-1.5',
      spacious: 'gap-3',
      display: 'gap-6',
    }[gap],
    {
      none: '',
      condensed: 'p-1',
      normal: 'p-1.5',
      spacious: 'p-3',
      display: 'p-6',
    }[padding],
  )
